/*********************
Frame Time Rule
*********************/
import Rule from './Rule';
import {
  ruleInputTypes,
  ruleTypes,
  frameTimeConditionValues,
  frameTimeEnums,
} from '../../constants';
import { LOG_DECISION_CONTEXT } from '../../config';

export default class FrameTimeRule extends Rule {
  constructor(frameTimeCondition) {
    super([ruleInputTypes.frameTimes, ruleInputTypes.wordIndex]);
    this.ruleType = ruleTypes.FRAME_TIME;
    this.frameTimeCondition = frameTimeCondition;
  }

  run(state) {
    // Get the params that we need to calculate probability of mastery
    let frameTimes = state.frameTimes;
    let wordIndex = state.wordIndex;

    // If this is a word level intervention, return true
    if(!state.endOfPhrase) {
      return {
        stateMeetsRuleCondition: true,
        decisionContext: this.ruleType + '_true - condition met by default due to not being applicable at word level',
        log: `PASSED: ${this.ruleType} qualified by default due to not being applicable at word level`,
      }
    }

    // If we're missing any inputTypes, return false
    let ruleParams = [frameTimes, wordIndex];
    const hasAllInputs = Object.values(ruleParams).every(input => (input !== null));
    if(!hasAllInputs) {
      console.log('Error: runRule called without all necessary inputs. This shouldn\'t ever occur: ', [ruleParams,this.inputTypes]);
      return false;
    }

    // Get the frametime for the selected rule
    let frameTime = frameTimes[wordIndex];
    if(!frameTime || !frameTime.frame || !frameTime.normalFrame) {
      return {
        stateMeetsRuleCondition: false,
        decisionContext: ('null frameTime for wordIndex ' + wordIndex + ' and frame times ' + frameTimes),
        log: `FAILED: ${this.ruleType} null frameTime - wordIndex:${wordIndex} frameTimes${frameTimes}`,
      }
    }

    const [frameTimeCondition, frameTimeConditionBool] = this.frameTimeCondition;

    let meetsFrameTimeCondition = false;
    switch(frameTimeCondition) {
      case frameTimeEnums.LONG:
        if(frameTime.normalFrame > frameTimeConditionValues.LONG) {
          meetsFrameTimeCondition = true;
        } else if(!frameTime.normalFrame) {
          meetsFrameTimeCondition = true;
        }
      break;
      case frameTimeEnums.SHORT:
        if(frameTime.normalFrame) {
          if(frameTime.normalFrame < frameTimeConditionValues.SHORT) {
            meetsFrameTimeCondition = true;
          }
        }
      break;
    }
    // invert decision based on user-specified bool
    if(!frameTimeConditionBool) {
      meetsFrameTimeCondition = !meetsFrameTimeCondition;
    }

    let decisionContext;
    let log;
    if(LOG_DECISION_CONTEXT) {
      decisionContext = {[(this.ruleType + '_' + this.frameTimeCondition + '_' + meetsFrameTimeCondition)]: {
        frameTime,
        wordIndex,
      }};

      log = `${meetsFrameTimeCondition ? 'PASSED': 'FAILED'}: FrameTimeRule=>` +
      [
        `(${!frameTimeConditionBool ? '!' : ''}${frameTimeCondition}: ${frameTimeConditionValues[frameTimeCondition]})`,
        `wordIndex: ${wordIndex}`,
        `studentArea: ${frameTime}`,
      ].join(', ');
    }

    return {
      stateMeetsRuleCondition: meetsFrameTimeCondition,
      decisionContext,
      log,
    }
  }
}